import { memo, useCallback, useState, lazy, Suspense } from 'react';
import { AspectRatio } from '@/components/ui/aspect-ratio';
import { useIsMobile } from '@/hooks/use-mobile';

// Lazy-load the entire YouTube component so mobile never downloads it
const YouTubeBackground = lazy(() =>
  import('@/components/YouTubeBackground').then((m) => ({ default: m.YouTubeBackground }))
);

export const HeroVideo = memo(() => {
  const [isVisible, setIsVisible] = useState(false);
  const handleVisible = useCallback(() => setIsVisible(true), []);
  const isMobile = useIsMobile();

  return (
    <section className="relative w-full bg-background pt-[56px] md:pt-[72px]">
      <AspectRatio ratio={16 / 9}>
        <div className="relative w-full h-full">
          {/* On mobile: static black background (saves ~730KB YouTube JS, zero network cost) */}
          {/* On desktop: lazy-loaded YouTube background video */}
          {!isMobile && (
            <Suspense fallback={null}>
              <YouTubeBackground videoId="ME9__rz0DlU" onVisible={handleVisible} />
            </Suspense>
          )}

          {/* Loading overlay / static bg for mobile */}
          <div
            className={`absolute inset-0 bg-black z-10 transition-opacity duration-700 ${
              isVisible && !isMobile ? 'opacity-0 pointer-events-none' : isMobile ? 'opacity-100' : 'opacity-100'
            }`}
          >
            {!isMobile && !isVisible && (
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 border-2 border-white/20 border-t-white/60 rounded-full animate-spin" />
              </div>
            )}
          </div>

          {/* Interaction blocker - prevents pause and hover overlays */}
          {!isMobile && <div className="absolute inset-0 z-20" />}
        </div>
      </AspectRatio>
    </section>
  );
});

HeroVideo.displayName = 'HeroVideo';
